module.exports = __webpack_public_path__ + "img/agriculture/badge1.547ae84b.png";